/**
 * L2-R5: moved verbatim from @shared/utils/tree-node/tree-node.
 * That host path is now a re-export shim of this file.
 */
export interface RawTreeNode {
  value: any;
  children?: RawTreeNode[];
}
export class TreeNode<T> {
  private readonly _value: any;
  public children;
  constructor(_data: T, field: string, children?: Array<TreeNode<T>>) {
    if (_data[field]) {
      this._value = _data[field];
    }
    if (children) {
      this.children = children;
    }
  }
  get value() {
    return this._value;
  }
  setChildren(children: Array<TreeNode<T>>) {
    this.children = children.filter(Boolean);
  }
  addChild(newChild: TreeNode<T>) {
    const existingNode = this.children.filter(Boolean).find(child => child.value === newChild.value);
    if (existingNode) {
      return existingNode.setChildren([...(existingNode.children || []), ...(newChild.children || [])]);
    }
    return this.children.push(newChild);
  }
  raw(): RawTreeNode {
    if (this.children && this.children.length) {
      return {
        value: this.value,
        children: this.children.map(child => child.raw()),
      };
    }
    return { value: this.value };
  }
}
